<div>
    <img [width]="width ? width : 190" [height]="height ? height : 153" src="assets/imgs/empty.svg" alt="empty image">
    <h1>{{'table.empty_data' | translate}}</h1>
    <p class="empty__text">{{'table.be_empty' | translate}}</p>
</div>